import * as React from 'react';
import DataGrid from '../form/DataGrid';

export default function EventsDataGrid(props = {}) {
  
  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        resource="events"
        initialColumnVisibilityModel={{
          createdAt: false,
        }}
        {...props}
      />
    </div>
  );
}